import type { SharedDCCTVolumeInfo } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { TOOTH_SLICE_THICKNESS_OPTIONS_MM } from '../config';

export const resolveToothSliceThicknessOptionsMm = (
  volumeInfo: SharedDCCTVolumeInfo | null,
): number[] => {
  const spacing = volumeInfo?.geometry.spacing;
  const coarsestMm = spacing ? Math.max(spacing.x, spacing.y, spacing.z) : 0;

  if (!Number.isFinite(coarsestMm) || coarsestMm <= 0) {
    return TOOTH_SLICE_THICKNESS_OPTIONS_MM;
  }

  const renderable = TOOTH_SLICE_THICKNESS_OPTIONS_MM.filter(
    (thicknessMm) => thicknessMm >= coarsestMm,
  );

  return renderable.length
    ? renderable
    : TOOTH_SLICE_THICKNESS_OPTIONS_MM.slice(-1);
};
